import React, { useState } from "react"
import "../../App.less"
import "../../styles/Benefits/IncomePlan.less"
import { observer } from "mobx-react"
import incomePlan from "../../Configs/JSON/incomePlan.json"
import AppStore from "../../Configs/Store/index"
import CalculatorStore from "../../Configs/Store/calculator"

const IncomePlan = observer((props) => {
  const device = AppStore.device

  return (
    <div className="IncomePlan_FlexBox RetirementFund">
      <div className="IncomePlan_Parent0 st">
        {CalculatorStore.incomeProp && <h1 className="ttl-1">{incomePlan["Heading1"]}</h1>}
        {/* { CalculatorStore.incomeProp && <div className="sb-ttl-1">{incomePlan["Heading2"]}</div> } */}
        {/* { CalculatorStore.incomeProp && <div className="heading">{incomePlan["Heading3"]}</div> } */}
        {!CalculatorStore.incomeProp && <div className="sb-ttl-2">{incomePlan["Heading5"]}</div>}
        {device === 1 && <div>{!CalculatorStore.incomeProp && <div className="ttl-2">{incomePlan["Heading4"]}</div>}</div>}
      </div>
    </div>
  )
})

export default IncomePlan
